import DataType from 'scoreboard/datasets/model/data-type'
const { COUNTRY, STATE_PROVINCE, CITY } = DataType

/**
 * @param dataType
 * @return {('country' | 'state-province' | 'city')[]}
 */
function getRequiredGeographicAncestorTypes(dataType) {
	const requiredTypes = []
	switch (dataType) {
		case 'address':
			requiredTypes.push(CITY)
		case 'county': case 'city':
			requiredTypes.push(STATE_PROVINCE)
		case 'voting-district': case 'postal-code': case 'state-province':
			requiredTypes.push(COUNTRY)
	}
	return requiredTypes
}

export default getRequiredGeographicAncestorTypes
getRequiredGeographicAncestorTypes.__filename__ = 'datasets/edit/fields/get-required-geographic-ancestor-types.js'
